export default {"src":"/_next/static/media/weth.19fa93ab.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};